import { useState } from 'react';


/*
CardCollapsible
INSPIRACIJA:
<details></details>
https://developer.mozilla.org/en-US/docs/Web/HTML/Element/details
https://docs.sheetjs.com/docs/
*/

/*
// ---------- CardCollapsible DOCUMENTATION ---------

----- CardCollapsible React props:

props.title
props.tooltip
props.jsxHeader
props.small

props.initialOpened


invisibleParent // niej vidljiv na ekranu ali sluzi da u njemu CardCollapsible budu kao vidljivi childreni

minWidth

fullWidth

extraClass

*/

const CardCollapsible = (props) => {
  let initialOpened = false;
  if (props.initialOpened === true) {
    initialOpened = true;
  }
  const [opened, setOpened] = useState(initialOpened);
  const [rendering, setRendering] = useState(initialOpened);

  let _trouglic = (e) => {
    // console.log('klik na trouglic');
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
      if (rendering !== true) {
        setRendering(true);
      }
    }
  }

  let alwaysOpened = false;
  if (props.alwaysOpened === true) {
    alwaysOpened = true;
  }

  let clOpened = ' widget-card-colapsible--closed';
  if (opened || alwaysOpened) {
    clOpened = ' widget-card-colapsible--opened ';
  }

  let extraClass = '';
  // if (typeof props.extraClass === 'string' && props.extraClass !== '') {
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }

  let jsxTitle = null;
  if (typeof props.title === 'string' && props.title !== '') {
    if (typeof props.tooltip === 'string' && props.tooltip !== '') {
      jsxTitle = (
        <div className="title">
          <abbr title={props.tooltip}>{props.title}</abbr>
        </div>
      );
    } else {
      jsxTitle = (
        <div className="title">{props.title}</div>
      );
    }
  }

  let style = {};
  if (props.minWidth > 0) {
    style = {
      minWidth: props.minWidth
    };
  }

  return (
    <div className={"widget-card-colapsible " + clOpened + extraClass + (props.small === true ? " widget-card-colapsible--small" : "") + (props.fullWidth === true ? " widget-card-colapsible--full-width" : "")} style={style}>
      <div className="widget-card-colapsible__header" onClick={_trouglic}>
        <div className="unicompo-rotating-triangle__aura-container">
          <div className="unicompo-rotating-triangle__aura-clickable">
            <i className="fa fa-caret-right" aria-hidden="true"></i>
          </div>
        </div>
        <div className="widget-card-colapsible__header-container uu-text-nowrap">
          {
            props.jsxHeader ? (props.jsxHeader) : (jsxTitle)
          }
        </div>
      </div>
      <div className="widget-card-colapsible__separator"></div>
      <div className="widget-card-colapsible__collapser">
        {
          opened === true && (props.children)
        }
      </div>
    </div>
  );
};

export default CardCollapsible;